import PlatformProxy from '@/core/PlatformProxy.ts';

export const getReqInstance = (config: any) => {
  return PlatformProxy.getInstance().getReqInstance(config);
};
